<template>
  <div class="blog-timeline-container">
    <v-virtual-scroll
      :items="timeLineData"
      :item-height="120"
      height="100%"
    >
      <template v-slot="{ item }">
        <v-timeline class="blog-timeline">
            <v-timeline-item
              v-for="(data, i) in timeLineData"
              :key="i" small
              :color="data.color">
              <template v-slot:icon>
                <v-avatar :color="data.color" size="36">
                  <span class="year-text">{{ data.year | cookYear }}</span>
                </v-avatar>
              </template>
              <template v-slot:opposite>
                <i :style="{color:data.color}" class="timeline-date-text"> {{ data.date }}</i>
              </template>

              <v-card dark max-width="320" @click="blogClickEvent(data)">
                <v-toolbar flat :color="data.color" dark tile>
                  <v-card-subtitle><b class="timeline-title-text">{{ data.title | cookTitle }}</b></v-card-subtitle> 
                </v-toolbar>
                <v-card-text class="white" style="height:50px" dark>
                  <v-btn icon v-for="item in data.tags" :key="item" class="blog-timeline-tag"><i style="color:#67C23A">{{ item }}</i></v-btn>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
      </template>
    </v-virtual-scroll>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    methods: {
      blogClickEvent(item){
        let path = item.path;
        this.$router.push({ path: "/blog/articles", query:{path: path}})
      }
    },
    filters: {
      cookYear(value){
        value = value + ""
        if(value){
          try {
            return value - 2000;
          } catch (error) {
            try {
              return value.substring(2,4);
            } catch (error) {
              return value;
            }
          }
        }
        return value
      }, 
      cookTag(value) {
        return 'fa-home'
      },
      cookTitle(value) {
        if(value && value.length > 32){
          return value.substring(0, 33) + "..."
        }
        return value
      },
    },
    computed: {
      timeLineData(){
        return this.$store.state.articlesTimeline;
      }
    },
  }
</script>

<style lang="stylus" scoped>
.blog-timeline-container
  top  0
  left 0
  width 100%
  height  100%
  overflow  auto
  position relative
  background-size cover
  background-image url('../assets/imgs/bg/13.jpg')

.blog-timeline
  left 32%
  max-width 660px
  height 100%
  overflow  auto

.timeline-date-text
  font-size 14px

.timeline-title-text
  font-size 14px
  font-weight 700px
  color  white

.year-text
  font-size 15px
  color #ffffff

.blog-timeline-tag
  margin-right  5px
  font-size 10px


</style>